import { createFormHook, createFormHookContexts } from '@tanstack/react-form';
import { TextInput } from './fieldComponents/TextInput';
import { SubmitButton } from './formComponents/SubmitButton';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm: useDatevAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextInput: TextInput,
  },
  formComponents: {
    SubmitButton: SubmitButton,
  },
});
